import React, { useState, useCallback } from "react";
import Emty from "../../components/Emty/Emty";
import PostListSection from "../../components/PostListSection/PostListSection";
import useGetPost from "../../hooks/UseGetPost";
import "./css/index.css";

const bbs_id = 4;

function Magagize() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [type, settype] = useState<string | undefined>(undefined);
  const [data, PostRemove, PagingUpdate, PostSearch, PostStateChange] =
    useGetPost({
      bbs_id,
      filter: type ? `&ctts_ctg_cd=${type}` : undefined,
    });
  const [search, setsearch] = useState<string>("");
  const __handleSearch = useCallback((e: string) => {
    setsearch(e);
  }, []);
  const __searchInit = useCallback(() => {
    PostSearch(search);
  }, [search]);
  const __changeFilter = useCallback((e: string | undefined) => {
    settype(e);
  }, []);

  return (
    <main className="magazine-page">
      <div className="wrapper">
        <div className="title">
          <div className="left">
            <p>게시중 매거진</p>
          </div>
          <div className="right">
            <div className="type-box-wrapper">
              <div className={`type_box ${isOpen ? "open" : ""}`}>
                <button
                  className="now"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  <div className="type">
                    {type
                      ? type === "MGN_01"
                        ? "월간 팀플리더"
                        : type === "MGN_02"
                        ? "팀플러 인터뷰"
                        : "워크 스토리"
                      : "유형 전체"}
                  </div>
                  <img
                    className="buttontype"
                    src="/assets/common/button.svg"
                  ></img>
                </button>
                {filterLayouts.map(({ title, type }, idx) => {
                  return (
                    <button
                      key={idx}
                      onClick={() => {
                        setIsOpen(false);
                        __changeFilter(type);
                      }}
                    >
                      {title}
                    </button>
                  );
                })}
              </div>
            </div>

            <form
              className="search_box"
              onSubmit={(e) => {
                __searchInit();
                e.preventDefault();
              }}
            >
              <input
                type="text"
                className="type2"
                placeholder="매거진 검색"
                onChange={(e) => {
                  __handleSearch(e.target.value);
                }}
              ></input>
              <img className="search" src="/assets/common/search.svg"></img>
            </form>
            <div className="button" onClick={__searchInit}>
              검색
            </div>
          </div>
        </div>
        {data.length > 0 ? (
          <PostListSection
            type="magazine"
            data={data}
            tags={tagLayouts}
            PostRemove={PostRemove}
            ProjectPause={undefined}
            category={undefined}
            ChangeProjectSts={undefined}
            __ChangeState={undefined}
            prjtData={undefined}
            PagingUpdate={PagingUpdate}
            PostStateChange={PostStateChange}
          />
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
}

export default Magagize;

const filterLayouts = [
  {
    title: "전체",
    type: undefined,
  },
  {
    title: "워크스토리",
    type: "MGN",
  },
  {
    title: "월간 팀플리더",
    type: "MGN_01",
  },
  {
    title: "팀플러 인터뷰",
    type: "MGN_02",
  },
];

const tagLayouts = [
  {
    title: "유형",
    type: "magazine-type",
  },
  {
    title: "매거진명",
    type: "magazine-title",
  },
  {
    title: "팀플리더/부제",
    type: "magazine-leader",
  },
  {
    title: "등록일",
    type: "magazine-timestamp",
  },
  {
    title: "노출여부",
    type: "magazine-show",
  },
  {
    title: "수정하기",
    type: "magazine-fix",
  },
  {
    title: "삭제하기",
    type: "magazine-delete",
  },
];
